import React from "react";
import L, { LatLngExpression } from "leaflet";
import { activeRouteType, wayCustom } from "../../services/bicycle_ways";

export function getActiveRoutes(layerRouteGroupRef: React.MutableRefObject<L.LayerGroup<any> | undefined>, activeRoutes: any) {
  if (layerRouteGroupRef.current) {
    let desc: any = null;
    let style: any = {
      color: 'grey',
      weight: 3,
      opacity: 1,
      dashArray: '10, 10', dashOffset: '5'
    };

    let styleBck: any = {
      color: 'white',
      weight: 5,
    };

    activeRoutes?.forEach((route: activeRouteType) => {

      if (route.hasOwnProperty("tags") && route?.tags) {
        desc = Object.entries(route?.tags).map(tag => tag.join(":")).join("\n, ");
      }

      let routeLine: LatLngExpression[] = [];

      route?.members.forEach((way: wayCustom) => {
        if (!Array.isArray(way?.nodes) || way.nodes.length < 2) {
          return;
        }

        const validNodes = way.nodes.filter((node: any) => node?.lat !== undefined && node?.lon !== undefined);
        if (validNodes.length < 2) {
          return;
        }

        routeLine = validNodes.map((node: any) => {
          return [node.lat, node.lon];
        });
        //SET background of line / outline
        const mapLineBck = L.polyline(routeLine, styleBck);
        if (layerRouteGroupRef.current)
          mapLineBck.addTo(layerRouteGroupRef.current);

        //SET main color of route line
        const mapLineFrd = L.polyline(routeLine, style);
        mapLineFrd.bindPopup(desc).bindTooltip(desc);
        if (layerRouteGroupRef.current)
          mapLineFrd.addTo(layerRouteGroupRef.current);
      });
      //cycle_network, from, to, state (propsed), networ: rcn, name, ref (nr),
      //description, type=route, distance
      // 
      if (route?.tags && (route.tags['type'] === "route" || route.tags['route'] === "bicycle")) {
        // style["borderStyle"] = "double";
        style["color"] = route.tags?.colour || route.tags?.color || "grey";
        // 
        // 
      }
    });
  }
}
